export const NPVR_PLAYLIST_RECEIVED = '@ZAPI_NPVR_PLAYLIST_RECEIVED';
export const NPVR_RECORDING_ADDED = '@ZAPI_NPVR_RECORDING_ADDED';
export const NPVR_RECORDING_UPDATED = '@ZAPI_NPVR_RECORDING_UPDATED';
export const NPVR_RECORDING_REMOVED = '@ZAPI_NPVR_RECORDING_REMOVED';
export const NPVR_BATCH_RECORDING_REMOVED = '@ZAPI_NPVR_BATCH_RECORDING_REMOVED';
export const NPVR_RECORDING_RESTORED = '@ZAPI_NPVR_RECORDING_RESTORED';
export const NPVR_STARTED_SERIES_RECORDING = '@ZAPI_NPVR_STARTED_SERIES_RECORDING';
export const NPVR_STOPPED_SERIES_RECORDING = '@ZAPI_NPVR_STOPPED_SERIES_RECORDING';
